export function addPadding(time: number) {
    return time < 10 ? "0" + time : time + "";
}